import { render, staticRenderFns } from "./ending.vue?vue&type=template&id=22234127&"
import script from "./ending.vue?vue&type=script&lang=js&"
export * from "./ending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports